(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ihl-boutique"] && !Shopify.designMode) return;
  try {
    
function ihlReveal(root) {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.animate([{opacity: .65, transform: 'translateY(14px)'}, {opacity: 1, transform: 'translateY(0)'}], {duration: 550, easing: 'ease-out'});
      observer.unobserve(entry.target);
    });
  }, {threshold: .12});
  root.querySelectorAll('[data-ihl-reveal]').forEach(el => observer.observe(el));
}
ihlReveal(document);
document.addEventListener('shopify:section:load', event => ihlReveal(event.target));

  } catch(e) { console.error(e); }
})();
})();
